import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import { Dictionary } from "src/app/store/models/common_types";
import { LineItemDelta, OptionsObject } from "../alerts.model";
import {
  VAIconRegistryService,
  exclamationTriangle,
  minus,
  plus,
  check,
  close,
} from "@va/core-library/icons";
@Component({
  selector: "app-line-item-delta-alert",
  templateUrl: "./line-item-delta-alert.component.html",
  styleUrls: ["./line-item-delta-alert.component.scss"],
})
export class LineItemDeltaAlertComponent implements OnInit {
  @Input() showSubscription = false;
  @Input() data: LineItemDelta;
  @Output() lidAlertDataChanged: EventEmitter<LineItemDelta> =
    new EventEmitter();
  baselineValue: string;
  percentageValue: string;
  periodValues = [];
  subscription: boolean;
  baselineOptions = [];
  percentageOptions = [];
  selectedPeriodOptions = [];
  showPeriodTooltip = false;
  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([
      exclamationTriangle,
      plus,
      minus,
      check,
      close,
    ]);
  }

  ngOnInit() {
    this.baselineOptions = this.convertToLabelValuePair(this.data.baseline);
    this.baselineValue = this.getSelectedValue(this.data.baseline);
    this.percentageOptions = this.convertToLabelValuePair(
      this.data.perc_change,
    );
    this.percentageValue = this.getSelectedValue(this.data.perc_change);
    this.periodValues = this.convertToLabelValuePair(
      this.data.selected_periods,
    );
  }

  /**
   *
   * @param list -- Array of objects whose value is true/false
   * @returns Array of objects
   * It takes a array of objects and transforms it to a UI friendly array of object which
   * is easy to use for rendering list of checkboxes or list of radio buttons in UI. Key of each
   * input object becomes label and value, and value of each object maps to checked attribute of
   * output object, which determines whether the radio/checkbox should be selected or not
   */
  convertToLabelValuePair(
    list: Array<Dictionary<boolean>> = [],
  ): Array<OptionsObject> {
    return list.map((item) => {
      const label = Object.keys(item)[0];
      const checked = Object.values(item)[0] as boolean;
      return {
        label,
        value: label,
        checked,
      };
    });
  }

  /**
   *
   * @param list -- Array of objects whose value is true/false
   * @returns string
   * Returns key of first object (out of list) whose value is true
   * It determines which value is selected out of group/list of radio buttons
   */
  getSelectedValue(list: Array<Dictionary<boolean>> = []): string {
    let selectedValue = "";
    const valIndex = list.findIndex(
      (baselineVal) => Object.values(baselineVal)[0],
    );
    if (valIndex > -1) {
      selectedValue = Object.keys(list[valIndex])[0];
    }
    return selectedValue;
  }
  /**
   *
   * @param list --> array of objects in UI supported format
   * @param selectedValue --> value to be marked as selected in list
   * @returns array of objects
   * It takes array of objects, which are in a format that UI understands and it takes a value to
   * be marked as selected in array of objects.
   * It marks that key as true and converts the list into a format that is understood by API.
   */
  getObjectForAPI(list, selectedValue): Array<Dictionary<boolean>> {
    return list.map((option) => ({
      [option.value]: option.value === selectedValue,
    }));
  }
  /**
   *
   * @param value --> string
   * It is called when baseline value is changed in UI
   */
  onBaselineChange(value): void {
    this.baselineValue = value;
    this.data.baseline = this.getObjectForAPI(this.baselineOptions, value);
    this.lidAlertDataChanged.emit(this.data);
  }

  /**
   *
   * @param value --> string
   * It is called when percentage value is changed in UI
   */
  onPercentageChange(value): void {
    this.percentageValue = value;
    this.data.perc_change = this.getObjectForAPI(this.percentageOptions, value);
    this.lidAlertDataChanged.emit(this.data);
  }

  /**
   *
   * @param values --> Array of period options
   * It is called when period selection is changed in UI
   */
  onPeriodChange(values): void {
    const isSomePeriodSelected = values.some((option) => option.checked);
    if (isSomePeriodSelected) {
      this.data.selected_periods = this.periodValues.map((option) => ({
        [option.value]: option.checked,
      }));
      this.lidAlertDataChanged.emit(this.data);
      this.showPeriodTooltip = false;
    } else {
      this.showPeriodTooltip = true;
      this.periodValues = this.convertToLabelValuePair(
        this.data.selected_periods,
      );
    }
  }

  onSubscriptionChange(value) {
    this.data.subscribed = value;
    this.lidAlertDataChanged.emit(this.data);
  }
}
